import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {sortedIndexByComparator} from '../../../common/sorted-index-by-comparator';
import {AutocompleteProvider, AutocompleteProviderConfig} from '../../autocomplete';
import {DexSecuritiesSubjectService} from '../../dex/dex-streaming/subjects/dex-securities-subject-service';
import {Deliverable} from '../../dex/dex-streaming/types/deliverable';
import {DeliverableCommonFilter} from './filters/deliverable-common-filter';

@Injectable()
export class DeliverableAutocompleteService implements AutocompleteProvider<Deliverable> {

    constructor(
        private dexSecuritiesSubjectService: DexSecuritiesSubjectService
    ) {}

    public autocomplete(term: string, config?: AutocompleteProviderConfig<Deliverable>): Observable<Deliverable[]> {
        const MAX_COUNT = 7;

        const filtered: Deliverable[] = [];
        const preparedTerm = (term || '').toLocaleLowerCase();

        for (const d of this.dexSecuritiesSubjectService.deliverableMapById.values()) {
            if (filtered.length >= MAX_COUNT) {
                break;
            }

            if (config?.filters?.length) {
                const isMatch = config.filters.every(f =>
                    !(f as DeliverableCommonFilter).match
                        || (f as DeliverableCommonFilter).match(d)
                );

                if (!isMatch) {
                    continue;
                }
            }

            if (!d.symbol.toLocaleLowerCase().startsWith(preparedTerm)) {
                continue;
            }

            const index = sortedIndexByComparator(
                filtered,
                d,
                (d1, d2) => d1.symbol.localeCompare(d2.symbol, undefined, {numeric: true})
            );
            filtered.splice(index, 0, d);
        }

        return of(filtered);
    }

}
